import cn from 'classnames';
import gsap from 'gsap';
import LogoFarm from 'react-scale/components/elements/logo-grid';
import Section from 'react-scale/components/elements/section';
import Marquee from 'react-fast-marquee';
import { Fragment, useEffect, useRef, useState } from 'react';

import { partnersData } from './data';

const Partners = () => {
  const [highlightedTitleIdx, setHighlightedTitleIdx] = useState(0);
  const sectionTitles = partnersData.map(({ sectionTitle }) => sectionTitle);
  const buttonsRef = useRef([]);

  useEffect(() => {
    const currentButton = buttonsRef.current[highlightedTitleIdx];

    const line = currentButton.querySelectorAll('.line');

    const tl = gsap.timeline();

    gsap.set(line, { opacity: 100 });
    tl.to(line, {
      scaleX: 1,
      duration: 4.5,
      ease: 'power2.inOut',
      onComplete: () => gsap.set(line, { opacity: 0, duration: 0.3, scaleX: 0 })
    });

    const timeout = setTimeout(() => {
      setHighlightedTitleIdx(prevState =>
        prevState === sectionTitles.length - 1 ? 0 : prevState + 1
      );
    }, 4500);

    return () => {
      clearTimeout(timeout);
      gsap.set(line, { opacity: 0, duration: 0.3, scaleX: 0 });
      tl.kill();
    };
  }, [highlightedTitleIdx]);

  return (
    <Section container={false} relative paddingBottom={false} paddingTop={false}>
      <div className="pb-20 pt-12 sm:pt-20 3xl:pb-28 3xl:pt-32">
        <div className="text-left mb-12 text-silver hidden lg:block">
          Scale works with{' '}
          {sectionTitles.map((sectionTitle, idx) => {
            const isHighlighted = idx === highlightedTitleIdx;
            return (
              <Fragment key={sectionTitle}>
                <button
                  ref={ref => buttonsRef.current.push(ref)}
                  className={cn(
                    'section-title inline-block relative cursor-pointer transition-colors duration-300',
                    isHighlighted && 'text-white'
                  )}
                  onClick={() => setHighlightedTitleIdx(idx)}
                  type="button"
                >
                  {sectionTitle}
                  <div
                    className={cn(
                      'transition-opacity duration-300 absolute bottom-0 h-[1px] w-full bg-silver',
                      isHighlighted ? 'opacity-100' : 'opacity-0'
                    )}
                  />
                  <div className="line opacity-0 scale-x-0 absolute bottom-0 h-[1px] w-full bg-white origin-left" />
                </button>
                {idx < sectionTitles.length - 2
                  ? ', '
                  : idx === sectionTitles.length - 2
                  ? ' & '
                  : ''}
              </Fragment>
            );
          })}
        </div>
        <div className="lg:block hidden relative h-14">
          {partnersData.map((section, idx) => {
            const isHighlighted = idx === highlightedTitleIdx;

            return (
              <div
                key={`${section.sectionTitle}-2`}
                className={cn(
                  'logos absolute w-full top-1/2 -translate-y-1/2 transition-opacity duration-700',
                  isHighlighted ? 'opacity-100 delay-300' : 'opacity-0'
                )}
              >
                <LogoFarm logos={section.logos} flex />
              </div>
            );
          })}
        </div>

        <div className="lg:hidden">
          <p className="text-left mb-8 text-silver">
            Scale works with{' '}
            {sectionTitles.map((sectionTitle, idx) => {
              return (
                <Fragment key={sectionTitle}>
                  <p className="inline-block">{sectionTitle}</p>
                  {idx < sectionTitles.length - 2
                    ? ', '
                    : idx === sectionTitles.length - 2
                    ? ' & '
                    : ''}
                </Fragment>
              );
            })}
          </p>
          <div className="w-screen relative left-1/2 -translate-x-1/2">
            <Marquee gradient={false} className="space-x-6">
              <LogoFarm
                flex
                logos={[
                  'microsoft',
                  'meta',
                  'openai',
                  'cohere',
                  'adept',
                  'carper',
                  'stability',
                  'character',
                  'usarmy',
                  'airforce',
                  'defense',
                  'cdao',
                  'microsoft',
                  'meta',
                  'gm',
                  'toyota',
                  'fox',
                  'accenture',
                  'koch',
                  'brex',
                  'flexport',
                  'instacart',
                  'faire',
                  'opensea',
                  'etsy'
                ]}
              />
            </Marquee>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Partners;
